module.exports = __webpack_public_path__ + "img/1.c42d5975.jpeg";